import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-orte-list-view',
  imports: [],
  templateUrl: './orte.list-view.html',
  styleUrls: ['./orte.list-view.css'],
})
export class OrteListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
